// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:31:20.162Z
// Property: The Pointe on Westshore (ID: 6767906449162940)
// Collections: 51 amenities, 11 floorplans (live), 43 photos, 6 POIs, 4 reviews, 5 virtual tours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162940",
  "property_external_id": "5329499",
  "property_zillow_url": "https://www.zillow.com/homedetails/4950-W-Prescott-St-Tampa-FL-33616/2062749600_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-pointe-on-westshore-tampa-fl/bz7m0dc",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-pointe-on-westshore",
  "property_name": "The Pointe on Westshore",
  "property_website_url": "https://www.thepointeonwestshore.com/",
  "property_domain": null,
  "property_address": "4950 W Prescott St",
  "property_full_address": "4950 W Prescott St",
  "property_address_1": "4950 W Prescott St",
  "property_address_2": null,
  "property_address_city": "Tampa",
  "property_address_state": "FL",
  "property_address_zip_full": "33616-2903",
  "property_address_zip": "33616",
  "property_address_country": "US",
  "property_address_county": "Hillsborough County",
  "property_neighborhood_address": "Port Tampa City",
  "property_address_latitude": "27.8668239",
  "property_address_longitude": "-82.5280629",
  "property_email": "westshore@alapts.com",
  "property_phone": "(813) 694-7990",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Pointe on Westshore in sunny Tampa, Florida! Choose from our spacious one, two, or three-bedroom floor plans, featuring amenities like a fitness center, dog park, and gated access. Find your new home today—browse our availability or schedule a tour to experience our vibrant community!",
  "property_long_description": "Welcome to The Pointe on Westshore, your ideal apartment community nestled in the heart of sunny Tampa, Florida. We offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments, each crafted with your lifestyle in mind. Whether you’re seeking a cozy one-bedroom retreat, a spacious two-bedroom for roommates, or a three-bedroom haven for your family, we have the perfect space for you.\n\nOur community is equipped with an array of amenities that will elevate your living experience. Stay active in our state-of-the-art fitness center, or unwind in one of our beautifully furnished units available for those who desire convenience without sacrificing style. For professionals, our business center provides a productive workspace, while our on-site maintenance and property management teams ensure a hassle-free living experience. \n\nThe Pointe on Westshore is a gated community, offering peace of mind with security features and convenient package services for your deliveries. Enjoy the outdoors with our dog park and bicycle storage—perfect for those who love to explore the vibrant surroundings.\n\nExperience the perfect blend of comfort and convenience at The Pointe on Westshore. Don’t miss the chance to find your new home in this captivating community! Browse our availability today or schedule a tour to see all that The Pointe on Westshore has to offer. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-e717-76a4-bbd3-9728217679c2.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with island and seating, adjacent to living room.",
    "public_id": "019cfddf-e717-76a4-bbd3-9728217679c2",
    "storage_key": "property/6767906449162940/019cfddf-e717-76a4-bbd3-9728217679c2.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "444",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.62162162162163",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-dc6c-731c-ae76-263a3850a58c.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddf-dc6c-731c-ae76-263a3850a58c",
    "storage_key": "property/6767906449162940/019cfddf-dc6c-731c-ae76-263a3850a58c.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-dc6c-731c-ae76-263a3850a58c.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddf-dc6c-731c-ae76-263a3850a58c",
    "storage_key": "property/6767906449162940/019cfddf-dc6c-731c-ae76-263a3850a58c.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "687 - 1469",
  "property_sqft_min": "687",
  "property_sqft_max": "1469",
  "property_price_range": "2053.33 - 3425.66",
  "property_price_min": "2053.33",
  "property_price_max": "3425.66",
  "property_available_units": 15,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding The Pointe on Westshore in Tampa, Florida. Our community offers spacious one, two, and three-bedroom floor plans designed for your comfort. Explore local favorites and nearby points of interest—see what’s around our community today! Your new home awaits amid Tampa's best attractions.",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Located in the southwestern-most portion of Tampa, Port Tampa City is a tranquil neighborhood between MacDill Air Force Base and the shores of Old Tampa Bay. Port Tampa City exudes a small-town feel defined by its welcoming community and laid-back atmosphere.\n\t\t\t\t\tThe neighborhood boasts a broad range of rentals, including apartments, condos, townhomes, and houses in varying styles and price points. Residents reap the benefits of a coastal lifestyle in Port Tampa City, from kayaking in the bay to taking Fido to the Picnic Island Beach Dog Park.\n\t\t\t\t\tAlthough Port Tampa City feels worlds away from the bustle of city life, the vibrant nightlife, shopping, and dining options of South Howard Avenue are just a short drive north. Downtown Tampa is also just a 20-minute drive from the neighborhood while Saint Petersburg Beach sits within a 40-minute drive.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Port Tampa City",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to The Pointe on Westshore in sunny Tampa, Florida! Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a fitness center, dog park, and on-site maintenance. Explore our amazing community amenities and apartment features today for your perfect living experience!",
  "property_applynow_blurb": "Discover your ideal living space at The Pointe on Westshore in Tampa, Florida! Choose from our spacious one, two, or three-bedroom floor plans. Enjoy top-notch amenities like a fitness center, gated access, and a dog park. Don't wait—find your new home and lease online today!",
  "property_contactus_blurb": "Discover your perfect home at The Pointe on Westshore in Tampa, Florida! Choose from our spacious one, two, or three-bedroom floor plans tailored for your lifestyle. Have questions? Contact our leasing team today and let us help you find your ideal apartment!",
  "property_faqs_blurb": "Discover your ideal home at The Pointe on Westshore in Tampa, Florida. With spacious one, two, and three-bedroom floor plans, we cater to all lifestyles. Have questions? Browse our FAQs page to find answers about our vibrant community and make your move to luxury living today!",
  "property_floorplans_blurb": "Discover your dream apartment at The Pointe on Westshore in vibrant Tampa, Florida! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Browse our available apartment homes today and find the perfect space that feels just like home!",
  "property_gallery_blurb": "Discover your dream home at The Pointe on Westshore in Tampa, Florida! Our vibrant community offers stunning one-, two-, and three-bedroom floor plans, along with exceptional amenities like a fitness center, dog park, and gated access. Picture yourself living here! Explore our photo gallery today and envision your new lifestyle.",
  "property_interactivemap_blurb": "Discover your ideal living space at The Pointe on Westshore in Tampa, Florida! Choose from spacious one, two, or three-bedroom floor plans and enjoy fabulous amenities like a fitness center, dog park, and on-site maintenance. Use our interactive community map to explore available apartments and find your new home today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "At The Pointe on Westshore in sunny Tampa, Florida, we offer stunning one, two, and three-bedroom floor plans tailored to your lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the benefits of living in a place you'll love together! View all options now!",
  "property_residentaccess_blurb": "Welcome to The Pointe on Westshore in vibrant Tampa, Florida! Explore our spacious one, two, and three-bedroom floor plans designed for your comfort. Access the resident portal today to effortlessly pay rent, schedule maintenance, and more! Experience convenient living at The Pointe—your ideal home awaits!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257816362",
  "property_scheduletour_blurb": "Discover your perfect home at The Pointe on Westshore in Tampa, Florida! Choose from spacious one, two, and three-bedroom floor plans designed for comfort and convenience. Ready for a visit? Schedule a tour today and see what our residents say about calling this vibrant community home!",
  "property_thankyou_blurb": "Thank you for reaching out to The Pointe on Westshore in Tampa, Florida! Explore our diverse floor plans, featuring one, two, and three-bedroom options tailored to your lifestyle. Stay tuned, as a member of our team will connect with you shortly to assist with your apartment search. ",
  "property_virtualtours_blurb": "Discover your perfect home at The Pointe on Westshore in Tampa, Florida! Explore our spacious one, two, and three-bedroom floor plans designed for modern living. Don’t miss the chance to see your future apartment—take a virtual tour of our beautiful community and find your dream rental today!",
  "property_copyright": "2025 All Rights Reserved. The Pointe on Westshore",
  "property_seo_title_home": "The Pointe on Westshore | Apartments in Tampa, Florida",
  "property_seo_description_home": "Discover your perfect home at The Pointe on Westshore in Tampa, Florida! Our stunning community offers one, two, and three-bedroom floor plans to suit your lifestyle. Enjoy top-notch amenities including a state-of-the-art fitness center, furnished units, a business center, and a relaxing dog park. With gated access, on-site maintenance, and convenient package services, we provide the ultimate living experience. Explore all we have to offer—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Tampa, Florida",
  "property_seo_description_floorplans": "Discover your ideal living space at The Pointe on Westshore in Tampa, Florida! Explore our diverse selection of floor plans, including one, two, and three-bedroom apartments tailored to fit your lifestyle. Ready to make a move? Browse our available apartment homes today and find the perfect floor plan for you!",
  "property_seo_title_amenities": "Amenities | Tampa, Florida Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at The Pointe on Westshore in Tampa, Florida! Our community offers a range of spacious one, two, and three-bedroom floor plans, complete with top-notch amenities. Enjoy a state-of-the-art fitness center, on-site maintenance, a business center, and a secure, gated environment. Plus, take advantage of our dog park and convenient package services. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Tampa, Florida",
  "property_seo_description_gallery": "Explore The Pointe on Westshore in Tampa, Florida! Discover our stunning photo gallery showcasing spacious one, two, and three-bedroom floor plans with top-notch amenities. Enjoy a fully equipped fitness center, convenient business center, and vibrant dog park—all within a gated community. Picture yourself living here and elevate your lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Pointe on Westshore Apartments",
  "property_seo_description_virtualtours": "Discover your future home at The Pointe on Westshore in beautiful Tampa, Florida! Explore our diverse selection of one, two, and three-bedroom floor plans tailored to fit your lifestyle. Take a virtual tour of our inviting community and see the exceptional amenities we have to offer. Don’t miss out—start your new adventure today!",
  "property_seo_title_interactivemap": "Interactive Map | The Pointe on Westshore Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at The Pointe on Westshore in Tampa, Florida! Explore our range of spacious one, two, and three-bedroom apartment floor plans, complete with top-notch amenities like a fitness center, dog park, and convenient package service. With an on-site property manager and maintenance team, your comfort is our priority. Use our interactive community map to find available apartments, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tampa, Florida",
  "property_seo_description_neighborhood": "Discover vibrant living at The Pointe on Westshore in Tampa, Florida! Explore our diverse floor plans, including one, two, and three-bedroom apartments, designed for comfort and style. Visit our Neighborhood page to uncover local favorites and nearby attractions. See what's around our community and make The Pointe your new home today!",
  "property_seo_title_contact": "Contact Us | The Pointe on Westshore",
  "property_seo_description_contact": "Discover your ideal home at The Pointe on Westshore in beautiful Tampa, Florida. Explore our variety of spacious floor plans including one, two, and three-bedroom apartments designed for your comfort. Have questions? Contact our leasing team today to learn more about your future apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Tampa, Florida",
  "property_seo_description_faqs": "Discover answers to your questions about The Pointe on Westshore, a premier apartment community in Tampa, Florida. Explore our diverse floor plans featuring one, two, and three-bedroom options, along with top-notch amenities like a fitness center, business center, gated access, and a dog park. Browse our FAQs page to learn more about our furnished units, onsite maintenance, and more! Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tampa, Florida",
  "property_seo_description_reviews": "Discover why residents love The Pointe on Westshore in Tampa, Florida! Check out our resident reviews and see how our one, two, and three-bedroom floor plans, along with top-notch amenities like a fitness center, dog park, and on-site management, create an exceptional living experience. Don't miss out—read what our community has to say today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tampa, Florida",
  "property_seo_description_applynow": "Discover your perfect home at The Pointe on Westshore in Tampa, Florida! Choose from spacious one, two, and three-bedroom floor plans, equipped with top-notch amenities like a fitness center, business center, and dog park. Enjoy the ease of furnished units, gated access, and on-site maintenance. Ready to make the move? Apply now and lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | The Pointe on Westshore",
  "property_seo_description_residentaccess": "\"Welcome to The Pointe on Westshore in sunny Tampa, Florida! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your community services. Log in now for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Pointe on Westshore",
  "property_seo_description_referafriend": "\"Refer a friend to The Pointe on Westshore in Tampa, FL! Enjoy vibrant living with great neighbors and community perks. Join us today—great friends make great neighbors! 🌴✨\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Pointe on Westshore",
  "property_seo_description_scheduletour": "Discover your new home at The Pointe on Westshore in sunny Tampa, Florida! Experience the perfect blend of luxury and comfort. Schedule a tour of our vibrant community today and see why our residents love calling The Pointe home!",
  "property_seo_title_privacy": "Privacy Policy | The Pointe on Westshore",
  "property_seo_description_privacy": "Discover how The Pointe on Westshore in Tampa, Florida, prioritizes your privacy. Our comprehensive privacy policy outlines how we protect your information while you enjoy our vibrant community. View our privacy policy to learn more!",
  "property_seo_title_accessibility": "Website Accessibility | The Pointe on Westshore",
  "property_seo_description_accessibility": "\"Discover The Pointe on Westshore in Tampa, Florida—where digital inclusion meets community living. Our Accessibility Statement reflects our commitment to ensuring everyone can enjoy our website seamlessly. Explore how we prioritize your needs and find your perfect apartment today!\"",
  "property_seo_title_sitemap": "Sitemap | The Pointe on Westshore",
  "property_seo_description_sitemap": "Discover your ideal living experience at The Pointe on Westshore in Tampa, Florida. Explore our comprehensive sitemap to easily navigate our community features, amenities, and available apartments. Your next home awaits—view our sitemap today!",
  "property_seo_title_thankyou": "Thank You | The Pointe on Westshore",
  "property_seo_description_thankyou": "Thank you for reaching out to The Pointe on Westshore! We appreciate your interest and will connect with you soon to discuss your ideal apartment in beautiful Tampa, Florida. Stay tuned for personalized assistance in finding your perfect home!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1781823353957",
  "amenities": [
    {
      "id": "ec_36aae740c4b1e1563baf3764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d377dadce5a5d182d193ead0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f83e2ddd58d54577b7ae331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04970d0bd4309a41c0a18018",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Wash Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3608ed2b11d8be9e42d249a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b81bb3a12509a361aa46396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61fdf4084fca329274766ad4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b7324a4ff2cec1574c8a4f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6db4e021bbab54d6d6bece1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cca2972e11cf2283da37394f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be4148ddc4a8707d8c21429a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d58e617023ac376634417cec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c7e781bab174809cfe44870",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2301897b9c3935020ff9511a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eced43f85dc675cedce3af76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53bd566e367527433d264956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f30971303c66c090b83acdba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a46b2924dc9c78f4a874397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Full Size Microwave",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef82b6c6ef30557dfcad8260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Lounge Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b34f222a442dafe5e40cf9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee66a4143875208571a9203a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7aa5599286b85474acd5b060",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Digital Moving Concierge Services by Updater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_528ea73277b0c4b19027ea93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated Community w/ Fob Access Buildings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86d7f134d45dd78db1819785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Generous Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_620d0e1e4c3d40a292f159a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Hotel-Inspired Services by Spruce",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d820f94f0c37a0ae6debc4c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Building Trash Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_076e1dc68b9e1cebf03b5dbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer and Dryers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdba18faef2bae438bc52929",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Junior Olympic Size Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08f4e1e82ea5059aa7a9880f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Leash-Free Bark Park & Pet Spa**",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0feca96e1ef6c553e1087b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Modern Outdoor Fitness Park**",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44bd95ededf75a5a9e60ef34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Poolside Grilling Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d82da298a5c9909118d927e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patio/ Balcony",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a5acb146387ffaa84268783",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72633b748bf8594e675359b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Subway Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c838fc9342f998869399ccd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Undermount Sink w/ Gooseneck Faucet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c541ef45770288ecf03e91d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Style Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_162343362ee2cf3b43c58835",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0e7391a0dc199ffb258ca0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e4591ef4171cf3ff22af8d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1aebe479df19f18c0a1813f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78b25fd0ebce5183cc03d234",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e19b49f7074c4e9426598dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b99237e53f70ad3f5e6afa19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c4b839de8a547d9e80d4fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d7cff39e7570a5bbca02ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef18859a95b596c33fe5aca5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_725a3ef1c59181ba7b06347a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_468df1ea56823d507313a377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_817c46195d993df4f447e18b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_048986f3f90726741a111609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_145a68cf1151541ab15498c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d6b594d60c4bcd7c0f98864a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-230f-727a-8742-c9b513ad5225.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with contemporary artwork and comfortable seating.",
        "public_id": "019cfddf-230f-727a-8742-c9b513ad5225",
        "storage_key": "property/6767906449162940/019cfddf-230f-727a-8742-c9b513ad5225.webp",
        "width": 984,
        "height": 164
      },
      "title": "Apartment",
      "description": "Stylish living area and kitchen featuring sleek cabinetry, granite countertops, and elegant decor. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Modern living room and kitchen with contemporary artwork and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Ik4YzlgKqviL4UFQlhwvQ3MtLYTmKf7fZp0WVct6XJI/102/image.jpg"
    },
    {
      "id": "ec_6bed8063babdbcb709ff7864",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2389-74d6-b271-f44687397df0.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sectional sofa, accent chairs, large windows, and TVs on a wood-paneled wall.",
        "public_id": "019cfddf-2389-74d6-b271-f44687397df0",
        "storage_key": "property/6767906449162940/019cfddf-2389-74d6-b271-f44687397df0.webp",
        "width": 984,
        "height": 554
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating, large screens for entertainment, and expansive windows offering scenic views.",
      "link": "false",
      "alt_text": "Modern lounge area with sectional sofa, accent chairs, large windows, and TVs on a wood-paneled wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZtAllgm0oDzh8eVHX1VM6an74J7WUYhMXbZ-mrVVojw/102/image.jpg"
    },
    {
      "id": "ec_ba53cfbc5bf7d4a4936239dd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-1fd4-73b4-85c7-28fedcbf18c0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees, surrounded by modern apartment buildings.",
        "public_id": "019cfddf-1fd4-73b4-85c7-28fedcbf18c0",
        "storage_key": "property/6767906449162940/019cfddf-1fd4-73b4-85c7-28fedcbf18c0.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our expansive swimming pool, complete with comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees, surrounded by modern apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nSQ1DJ3qQ0CBaIFFuqgHHCYvaZBEfpEjEXi37GAw-_E/102/image.jpg"
    },
    {
      "id": "ec_d6328a08b6320361f28127e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2313-74ce-8045-6a44d1b43db7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and open-concept living area.",
        "public_id": "019cfddf-2313-74ce-8045-6a44d1b43db7",
        "storage_key": "property/6767906449162940/019cfddf-2313-74ce-8045-6a44d1b43db7.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed apartment featuring a spacious kitchen with a large island, perfect for cooking and entertaining. Enjoy the open-concept layout flowing into the living area.",
      "link": "false",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and open-concept living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MbmHwyqBYutdWD0TkgMFitLu6rDG4RXEZyDmtrM0TQY/113/image.jpg"
    },
    {
      "id": "ec_a801ed7315236756478d3654",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2cbd-76ef-892e-436d6ca2a262.webp",
      "image_media": {
        "alt_text": "Modern apartment living area with kitchen island, dining table, and view into bedroom.",
        "public_id": "019cfddf-2cbd-76ef-892e-436d6ca2a262",
        "storage_key": "property/6767906449162940/019cfddf-2cbd-76ef-892e-436d6ca2a262.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring a fully equipped kitchen with an island, a comfortable living area, and a dining space, perfect for everyday living and entertaining.",
      "link": "false",
      "alt_text": "Modern apartment living area with kitchen island, dining table, and view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/acewyxr4C5BPVi1uWwrCjNZSvWmu3mqCLCXvac5ojD4/112/image.jpg"
    },
    {
      "id": "ec_a8c50881d1c184fc689062d3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3007-73ed-9222-7c8c4065994d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
        "public_id": "019cfddf-3007-73ed-9222-7c8c4065994d",
        "storage_key": "property/6767906449162940/019cfddf-3007-73ed-9222-7c8c4065994d.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Discover your dream kitchen featuring sleek white cabinetry, state-of-the-art stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Cieba-G9vkeyzNrCEYPzPhxXYJ3FBO6MDUDI8clsJ90/113/image.jpg"
    },
    {
      "id": "ec_51d91acf6458d24b9e1f04e4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-1fd4-73b4-85c7-28fedcbf18c0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees, surrounded by modern apartment buildings.",
        "public_id": "019cfddf-1fd4-73b4-85c7-28fedcbf18c0",
        "storage_key": "property/6767906449162940/019cfddf-1fd4-73b4-85c7-28fedcbf18c0.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our expansive swimming pool, complete with comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees, surrounded by modern apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nSQ1DJ3qQ0CBaIFFuqgHHCYvaZBEfpEjEXi37GAw-_E/102/image.jpg"
    },
    {
      "id": "ec_593676fa84e29470004c3433",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3008-7702-937a-0c19127d644f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating.",
        "public_id": "019cfddf-3008-7702-937a-0c19127d644f",
        "storage_key": "property/6767906449162940/019cfddf-3008-7702-937a-0c19127d644f.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and stylish outdoor seating areas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MdiAdRP3IXiIggSUeRKdto3XnMRArCTpBCraZ7O4y2M/119/image.jpg"
    },
    {
      "id": "ec_4a0f2a04890d8f1a3cc1bc09",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2e4b-7784-a369-0aa8dd1c2657.webp",
      "image_media": {
        "alt_text": "View of a resort-style swimming pool and modern apartment buildings from a screened-in balcony with seating.",
        "public_id": "019cfddf-2e4b-7784-a369-0aa8dd1c2657",
        "storage_key": "property/6767906449162940/019cfddf-2e4b-7784-a369-0aa8dd1c2657.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and modern amenities from your private screened-in balcony, perfect for relaxing and taking in the beautiful community views.",
      "link": "false",
      "alt_text": "View of a resort-style swimming pool and modern apartment buildings from a screened-in balcony with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/64G-cdQee4zr63IIG0Kam4NUDqr1uaPdFrHvvPasinM/102/image.jpg"
    },
    {
      "id": "ec_9d1507b4a0048e962863252f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3aef-71ef-b8a3-c756f244105c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019cfddf-3aef-71ef-b8a3-c756f244105c",
        "storage_key": "property/6767906449162940/019cfddf-3aef-71ef-b8a3-c756f244105c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, surrounded by lush landscaping and modern amenities. Relax in our comfortable lounge chairs or take a dip in the crystal-clear water.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OqZVmO5fPproZGSDVBp6-IuI2dy9Q5q67qg6ukIO5Ag/119/image.jpg"
    },
    {
      "id": "ec_123f7936e42049f89320c435",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3aa7-761a-a85d-b4dd6b257da3.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with blue and white exteriors and attached garages.",
        "public_id": "019cfddf-3aa7-761a-a85d-b4dd6b257da3",
        "storage_key": "property/6767906449162940/019cfddf-3aa7-761a-a85d-b4dd6b257da3.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Exterior view of contemporary apartment buildings featuring a mix of blue and white facades, private garages, and lush landscaping.",
      "link": "false",
      "alt_text": "Modern apartment buildings with blue and white exteriors and attached garages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Vo4mlkBq0KTxe_gNs2AYsrCnnq4769d_jz6JXg_Mpxw/102/image.jpg"
    },
    {
      "id": "ec_1cb5076d0808f2dcacf2a38c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3e65-7261-8995-e4f8dd1a732c.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with modern seating and ocean view.",
        "public_id": "019cfddf-3e65-7261-8995-e4f8dd1a732c",
        "storage_key": "property/6767906449162940/019cfddf-3e65-7261-8995-e4f8dd1a732c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy breathtaking ocean views from the rooftop lounge, featuring comfortable seating and a serene atmosphere perfect for relaxation.",
      "link": "false",
      "alt_text": "Rooftop lounge area with modern seating and ocean view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YL3bStDDXnyO9YdEoH9pO5s9KWVf6OYsf_0WQw2wKmA/119/image.jpg"
    },
    {
      "id": "ec_bdd3fd884056327905cd6c3e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3f66-74e9-90d1-0e51f9dd6f25.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with white and blue siding and parked cars.",
        "public_id": "019cfddf-3f66-74e9-90d1-0e51f9dd6f25",
        "storage_key": "property/6767906449162940/019cfddf-3f66-74e9-90d1-0e51f9dd6f25.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building featuring white and blue facade, balconies, and a parking lot with several cars.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with white and blue siding and parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8dceCB7rdnK1ic7d_nBP5qVRR3WgYHAszHov2fR4mew/102/image.jpg"
    },
    {
      "id": "ec_56ac08bddc558bc92e075de2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-488d-740b-85a4-e85483abc47c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
        "public_id": "019cfddf-488d-740b-85a4-e85483abc47c",
        "storage_key": "property/6767906449162940/019cfddf-488d-740b-85a4-e85483abc47c.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring stainless steel appliances, ample cabinet space, and a functional island perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QxK5y9m1DIMCVouh6Xm9hbLL5snu8Sk8uvXIJyWBnQ0/118/image.jpg"
    },
    {
      "id": "ec_584aa4664c140a16ca5cecac",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-45d2-7345-996a-9b8c99a4d94e.webp",
      "image_media": {
        "alt_text": "Modern apartment fitness center with treadmills, rowing machines, and ellipticals.",
        "public_id": "019cfddf-45d2-7345-996a-9b8c99a4d94e",
        "storage_key": "property/6767906449162940/019cfddf-45d2-7345-996a-9b8c99a4d94e.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines and strength training equipment for your workout needs.",
      "link": "false",
      "alt_text": "Modern apartment fitness center with treadmills, rowing machines, and ellipticals.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Tes77k73Ik7mns0ivH-Hei__bnpovN8XcQF1DrMlp2c/102/image.jpg"
    },
    {
      "id": "ec_a6066a8bc6b895fd9d3e1527",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-4d39-71e1-bdcf-5dc6b070e005.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops.",
        "public_id": "019cfddf-4d39-71e1-bdcf-5dc6b070e005",
        "storage_key": "property/6767906449162940/019cfddf-4d39-71e1-bdcf-5dc6b070e005.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "This contemporary kitchen features sleek white cabinetry, stainless steel appliances including a microwave and oven, and elegant dark countertops, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VQs3wSqanbKVGHcu8FOlv9mkwovXtbP1BLq3RUbqFaw/118/image.jpg"
    },
    {
      "id": "ec_0dc5b2b7e9a2cf6fd94154c9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-4d1d-71d3-ad44-b50ab908b081.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and seating.",
        "public_id": "019cfddf-4d1d-71d3-ad44-b50ab908b081",
        "storage_key": "property/6767906449162940/019cfddf-4d1d-71d3-ad44-b50ab908b081.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, perfect for your furry friends to play and socialize. Features include agility equipment and comfortable seating for owners.",
      "link": "false",
      "alt_text": "Dog park with agility equipment and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/enOuI5Rlh5D35twJAzkpGmrwcwEPLhpcDzrGYZcZSu8/102/image.jpg"
    },
    {
      "id": "ec_04c11d35d040e9f16d2bf9b4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5499-71db-b131-190871a6d18e.webp",
      "image_media": {
        "alt_text": "A modern living room with a gray sofa, accent chairs, and a black and white striped rug.",
        "public_id": "019cfddf-5499-71db-b131-190871a6d18e",
        "storage_key": "property/6767906449162940/019cfddf-5499-71db-b131-190871a6d18e.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment living room, featuring a plush sofa, elegant decor, and large windows for ample natural light.",
      "link": "false",
      "alt_text": "A modern living room with a gray sofa, accent chairs, and a black and white striped rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hkeX-LN2RjcfgV4tzc59wgMAyFb7Yw-OG_kEN4UynTM/119/image.jpg"
    },
    {
      "id": "ec_601b5165fe3a52838a709f35",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-55f5-7733-87e5-579b88a7c1e3.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with blue seating and tables, Westshore Club building signage in background.",
        "public_id": "019cfddf-55f5-7733-87e5-579b88a7c1e3",
        "storage_key": "property/6767906449162940/019cfddf-55f5-7733-87e5-579b88a7c1e3.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish outdoor lounge at Westshore Club, featuring comfortable seating and modern tables perfect for socializing or enjoying the fresh air.",
      "link": "false",
      "alt_text": "Outdoor lounge area with blue seating and tables, Westshore Club building signage in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/laEVoqPrTkU_cH0tQYtnhuScJjQM_BtLJJ_Qx6Nh4oM/102/image.jpg"
    },
    {
      "id": "ec_ee195b707b00cee03cdaf0b5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5bc3-70bd-9d93-3636d3319a48.webp",
      "image_media": {
        "alt_text": "A well-lit bedroom featuring a king-size bed with white linens, decorative pillows, and a throw blanket. Artwork adorns the wall above the headboard. A ceiling fan circulates air, and a closet is visible to the left.",
        "public_id": "019cfddf-5bc3-70bd-9d93-3636d3319a48",
        "storage_key": "property/6767906449162940/019cfddf-5bc3-70bd-9d93-3636d3319a48.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom. Featuring a plush king-size bed, elegant decor, and ample closet space, it offers a serene retreat.",
      "link": "false",
      "alt_text": "A well-lit bedroom featuring a king-size bed with white linens, decorative pillows, and a throw blanket. Artwork adorns the wall above the headboard. A ceiling fan circulates air, and a closet is visible to the left.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aEr6wyqJWIR-EJ-Bw7rMdNpqVPqvfybVITh1rk_ggkE/119/image.jpg"
    },
    {
      "id": "ec_f961248b5fd9b75f7ded6e4f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5ac6-7725-90da-53b58f6ab3d2.webp",
      "image_media": {
        "alt_text": "Modern community lounge with two shuffleboard tables, bar area, and seating.",
        "public_id": "019cfddf-5ac6-7725-90da-53b58f6ab3d2",
        "storage_key": "property/6767906449162940/019cfddf-5ac6-7725-90da-53b58f6ab3d2.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy leisure time in our stylish community lounge, featuring shuffleboard tables and a convenient bar area.",
      "link": "false",
      "alt_text": "Modern community lounge with two shuffleboard tables, bar area, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/iU0BCLhhtGV4BC44Dusx96KuJ_Tj-2zXj2IngEbN7MY/102/image.jpg"
    },
    {
      "id": "ec_0dbb88e0f89f24e84f6b01e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-6165-761d-84b9-8cffecc3d2ae.webp",
      "image_media": {
        "alt_text": "Double vanity with illuminated mirrors and a walk-in shower.",
        "public_id": "019cfddf-6165-761d-84b9-8cffecc3d2ae",
        "storage_key": "property/6767906449162940/019cfddf-6165-761d-84b9-8cffecc3d2ae.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a double vanity with sleek cabinetry, illuminated mirrors, and a spacious walk-in shower with tiled walls.",
      "link": "false",
      "alt_text": "Double vanity with illuminated mirrors and a walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1g02mHGeGMG5JfFbT8Pusj6dbIA1_dV_2zYc43k-kGE/119/image.jpg"
    },
    {
      "id": "ec_77be9bdf018807ccd9e8355c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5fb1-71b8-8f5c-0ebe0c0c4e03.webp",
      "image_media": {
        "alt_text": "Gym with exercise equipment including stationary bikes, yoga mats, resistance bands, and medicine balls.",
        "public_id": "019cfddf-5fb1-71b8-8f5c-0ebe0c0c4e03",
        "storage_key": "property/6767906449162940/019cfddf-5fb1-71b8-8f5c-0ebe0c0c4e03.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and a variety of exercise equipment for a comprehensive workout.",
      "link": "false",
      "alt_text": "Gym with exercise equipment including stationary bikes, yoga mats, resistance bands, and medicine balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1WepTTeLr-nslIRax9HMPKQ9uMNjOFtH-H5irU-s9ss/102/image.jpg"
    },
    {
      "id": "ec_5e0c2701557fbdb13d745a58",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-652f-70cc-b519-3469de3d435a.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with storage shelf above.",
        "public_id": "019cfddf-652f-70cc-b519-3469de3d435a",
        "storage_key": "property/6767906449162940/019cfddf-652f-70cc-b519-3469de3d435a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs, with a handy shelf for storage.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with storage shelf above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uMMIn1v3E9Obv3BtSdoN_CYQD9hAiKjdZgcxtxFv0T0/119/image.jpg"
    },
    {
      "id": "ec_b2f3b7e14fc897d704d06c7d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-677a-72d9-a799-ff9f1c111e05.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a sectional sofa, accent chairs, and three TVs on a wood-slatted wall.",
        "public_id": "019cfddf-677a-72d9-a799-ff9f1c111e05",
        "storage_key": "property/6767906449162940/019cfddf-677a-72d9-a799-ff9f1c111e05.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Relax and unwind in our modern lounge area, featuring comfortable seating and entertainment options.",
      "link": "false",
      "alt_text": "Stylish lounge area with a sectional sofa, accent chairs, and three TVs on a wood-slatted wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/S_FINTEINdw9bK8iD5J2zWQ58sXoQZWITRBFHYIBLJE/102/image.jpg"
    },
    {
      "id": "ec_6b2b7fe798a2ce58746c30c5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-6ca5-726c-9ef9-01516e2257fc.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island and bar stools.",
        "public_id": "019cfddf-6ca5-726c-9ef9-01516e2257fc",
        "storage_key": "property/6767906449162940/019cfddf-6ca5-726c-9ef9-01516e2257fc.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Stylish open-concept kitchen and living space featuring a large island, sleek cabinetry, and comfortable seating, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with island and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/I6dHk6ts9UBuR6HJBNj7rcv-flOXADwpm6bd_cXPy0Q/119/image.jpg"
    },
    {
      "id": "ec_f05c5eb4434e291453c66b8a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-6b9b-70fa-9d46-a3e41e3e1a69.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, marble coffee table, and a glimpse into a bedroom.",
        "public_id": "019cfddf-6b9b-70fa-9d46-a3e41e3e1a69",
        "storage_key": "property/6767906449162940/019cfddf-6b9b-70fa-9d46-a3e41e3e1a69.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, a unique marble coffee table, and elegant decor, with a view into a serene bedroom.",
      "link": "false",
      "alt_text": "Modern living room with gray sofa, marble coffee table, and a glimpse into a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NsibIc4ItLb6HbdRHJy2xJ06JGWUNKx-sl8KtAJJLGo/102/image.jpg"
    },
    {
      "id": "ec_9efad2a49ed220a38585b5e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-70df-707b-8156-a19953c6a7cf.webp",
      "image_media": {
        "alt_text": "Fitness center with weights, cardio machines, and benches.",
        "public_id": "019cfddf-70df-707b-8156-a19953c6a7cf",
        "storage_key": "property/6767906449162940/019cfddf-70df-707b-8156-a19953c6a7cf.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and strength training machines for a complete workout experience.",
      "link": "false",
      "alt_text": "Fitness center with weights, cardio machines, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nr7pSEAnOviUXX1iU2M5rdUj8PCZGMoorDxu-Bc7_vU/119/image.jpg"
    },
    {
      "id": "ec_a6b582cd3b1b4f49b86c6d37",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-73e7-72e8-b816-ba5cf3fdef11.webp",
      "image_media": {
        "alt_text": "King size bed with white linens and gray accent pillows in a bedroom with dark gray walls and large windows.",
        "public_id": "019cfddf-73e7-72e8-b816-ba5cf3fdef11",
        "storage_key": "property/6767906449162940/019cfddf-73e7-72e8-b816-ba5cf3fdef11.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a king size bed, plush bedding, and elegant decor. Large windows provide ample natural light.",
      "link": "false",
      "alt_text": "King size bed with white linens and gray accent pillows in a bedroom with dark gray walls and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eW1DVbRfaDxJderz6i05BOb2PfVKrKTAVZQLhPqEQBY/102/image.jpg"
    },
    {
      "id": "ec_a209d44169f988b8a5d06885",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-78a9-7527-97ee-8fb525fb8bca.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and wooden hangers.",
        "public_id": "019cfddf-78a9-7527-97ee-8fb525fb8bca",
        "storage_key": "property/6767906449162940/019cfddf-78a9-7527-97ee-8fb525fb8bca.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving and natural wood hangers, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving and wooden hangers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qNT01zopaKJOicZ494GjZCeecl9necqRab68_RPGD9E/119/image.jpg"
    },
    {
      "id": "ec_f7d6cfbb8947ddd36e0fedcb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-77bf-726b-8ca3-89ba7d30fbbd.webp",
      "image_media": {
        "alt_text": "The Pointe Cafe area with coffee station, microwave, and seating.",
        "public_id": "019cfddf-77bf-726b-8ca3-89ba7d30fbbd",
        "storage_key": "property/6767906449162940/019cfddf-77bf-726b-8ca3-89ba7d30fbbd.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Enjoy a fresh coffee at The Pointe Cafe, equipped with a microwave, mini-fridge, and comfortable seating.",
      "link": "false",
      "alt_text": "The Pointe Cafe area with coffee station, microwave, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HxVXkkook6skFBtpfXyzNuFK3Aqw6JQs3XcwS69sYXs/102/image.jpg"
    },
    {
      "id": "ec_c6f4288bd18162457363100b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-7e67-761a-831e-cee756361e8d.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex with a resort-style pool and lounge chairs.",
        "public_id": "019cfddf-7e67-761a-831e-cee756361e8d",
        "storage_key": "property/6767906449162940/019cfddf-7e67-761a-831e-cee756361e8d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool area at this luxury apartment community, complete with ample lounge seating and modern building architecture.",
      "link": "false",
      "alt_text": "Luxury apartment complex with a resort-style pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qPRCZKec6xb640nAFaSb-vprBT0yvhfPAREbl7wzQ3w/119/image.jpg"
    },
    {
      "id": "ec_dff67ee4087f738204ba91cc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-809f-7454-a1a4-d1ffbf0bc16d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and living area",
        "public_id": "019cfddf-809f-7454-a1a4-d1ffbf0bc16d",
        "storage_key": "property/6767906449162940/019cfddf-809f-7454-a1a4-d1ffbf0bc16d.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area with a modern kitchen island, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island and living area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jc50uYgVcHZj7CWCrw_zfs1SFjTBeV2tuzhIGW9wRhE/102/image.jpg"
    },
    {
      "id": "ec_468da6bff50833f461ba7b03",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-84ea-758b-a68a-ef16237936e5.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, walk-in closet, and decorative wall hanging.",
        "public_id": "019cfddf-84ea-758b-a68a-ef16237936e5",
        "storage_key": "property/6767906449162940/019cfddf-84ea-758b-a68a-ef16237936e5.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious bedroom, complete with a large walk-in closet and stylish decor.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed, walk-in closet, and decorative wall hanging.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3s7t7OIaRN9bDJGa-mPnPC6pjZ7q7w9TjC3yLaZJ3r0/119/image.jpg"
    },
    {
      "id": "ec_d533d0ba8e32507c79f2daba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-828e-716a-ab76-a211c6ab962e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with illuminated mirror, vanity, toilet, and view into bedroom.",
        "public_id": "019cfddf-828e-716a-ab76-a211c6ab962e",
        "storage_key": "property/6767906449162940/019cfddf-828e-716a-ab76-a211c6ab962e.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed bathroom featuring a spacious vanity with an illuminated mirror, modern fixtures, and a separate toilet area. Enjoy the view into the adjacent bedroom.",
      "link": "false",
      "alt_text": "Modern bathroom with illuminated mirror, vanity, toilet, and view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Oar5H68oopOFh7PlX4ZQmnANvfH8Ys1mPfMf7XX7S6s/102/image.jpg"
    },
    {
      "id": "ec_f2bc45578210d015c043069b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-8828-75bd-8097-616ffbf06560.webp",
      "image_media": {
        "alt_text": "Exterior view of a large, multi-story apartment building under construction, with surrounding construction equipment and temporary structures.",
        "public_id": "019cfddf-8828-75bd-8097-616ffbf06560",
        "storage_key": "property/6767906449162940/019cfddf-8828-75bd-8097-616ffbf06560.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "An aerial view showcases the exterior of a modern apartment building in its construction phase, highlighting its facade and the surrounding active development.",
      "link": "false",
      "alt_text": "Exterior view of a large, multi-story apartment building under construction, with surrounding construction equipment and temporary structures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/oZQ7EfNTAY2MnF_b9IQj1O5LbFs74pgN4F3kJAyrTEg/115/image.jpg"
    },
    {
      "id": "ec_4d41aba57a5b774f88ef067e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-8d73-72ef-95b8-91ab55abf7a6.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex under construction with buildings facing a body of water and a bridge in the distance.",
        "public_id": "019cfddf-8d73-72ef-95b8-91ab55abf7a6",
        "storage_key": "property/6767906449162940/019cfddf-8d73-72ef-95b8-91ab55abf7a6.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the modern architecture of the apartment complex, with multiple buildings and waterfront vistas.",
      "link": "false",
      "alt_text": "Aerial view of a modern apartment complex under construction with buildings facing a body of water and a bridge in the distance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gk7Sb6FaUEecVPVts8DargmmUsPM2a3dD6LPfdB-U-k/112/image.jpg"
    },
    {
      "id": "ec_7067981dd0fccf32f573cf53",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-952a-712e-ad34-a07ec18c51b2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings under construction with stacked building materials.",
        "public_id": "019cfddf-952a-712e-ad34-a07ec18c51b2",
        "storage_key": "property/6767906449162940/019cfddf-952a-712e-ad34-a07ec18c51b2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Under construction apartment buildings with stacked materials like windows and wood planks. Site work in progress with dirt mounds and a drainage ditch.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings under construction with stacked building materials.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AYTbgixvFpmgHIFOPyZGUA2ndGhYC3xptWdq_FymjBI/116/image.jpg"
    },
    {
      "id": "ec_6fc878044d21fc4af36d7cbb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-9191-7416-ab98-cb34fba6406a.webp",
      "image_media": {
        "alt_text": "Exterior aerial view of apartment buildings under construction with palm trees and a water feature.",
        "public_id": "019cfddf-9191-7416-ab98-cb34fba6406a",
        "storage_key": "property/6767906449162940/019cfddf-9191-7416-ab98-cb34fba6406a.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Aerial view of a new multifamily property development featuring multiple apartment buildings, townhomes, and surrounding landscape, showcasing the ongoing construction progress.",
      "link": "false",
      "alt_text": "Exterior aerial view of apartment buildings under construction with palm trees and a water feature.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uw_YV78sU0SU0f8i_fe2HdZNzuuqFTCqMDIaQQPfGQ4/115/image.jpg"
    },
    {
      "id": "ec_9dc079c3c9f19ee6210134dc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-9789-756c-b2b1-f420dc666fb8.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property under construction, showing multiple apartment buildings and surrounding infrastructure.",
        "public_id": "019cfddf-9789-756c-b2b1-f420dc666fb8",
        "storage_key": "property/6767906449162940/019cfddf-9789-756c-b2b1-f420dc666fb8.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "An aerial perspective of a new multifamily property development, highlighting the construction progress of modern apartment buildings and the surrounding urban landscape.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property under construction, showing multiple apartment buildings and surrounding infrastructure.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/a59J7ZIVQ0S0N5Awq9OKSoKzDL0k7z6f9oGOzllDxoM/116/image.jpg"
    },
    {
      "id": "ec_d647f482928a9976ce24f02c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-9e5c-761a-919a-5deedc4ddef8.webp",
      "image_media": {
        "alt_text": "Entrance gate and buildings of a multifamily property.",
        "public_id": "019cfddf-9e5c-761a-919a-5deedc4ddef8",
        "storage_key": "property/6767906449162940/019cfddf-9e5c-761a-919a-5deedc4ddef8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to the entrance of this beautiful multifamily property, featuring modern architecture and a secure gated entry.",
      "link": "false",
      "alt_text": "Entrance gate and buildings of a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Y6i96u1RGlUW60LHk1UyWqr_rEyekiL2pRzkQGNMUdw/114/image.jpg"
    },
    {
      "id": "ec_bb440948ff90652b9e07a4b4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-a16b-7053-88d7-832a38fb7b19.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with a gated entrance and palm trees.",
        "public_id": "019cfddf-a16b-7053-88d7-832a38fb7b19",
        "storage_key": "property/6767906449162940/019cfddf-a16b-7053-88d7-832a38fb7b19.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the gated entrance and modern apartment buildings with a clear blue sky overhead.",
      "link": "false",
      "alt_text": "Modern apartment buildings with a gated entrance and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/W1GTWO9IVMyhSlbAANIoFW08JW8RTXKGCiJSUqJvhS8/115/image.jpg"
    },
    {
      "id": "ec_2ad0e7ffa1c03d381ddf4238",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-a484-741f-b175-97a1194700dc.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with a Wheaton World Wide Moving truck parked in the circular driveway.",
        "public_id": "019cfddf-a484-741f-b175-97a1194700dc",
        "storage_key": "property/6767906449162940/019cfddf-a484-741f-b175-97a1194700dc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to your new home! Experience modern living with our spacious apartment buildings and convenient amenities.",
      "link": "false",
      "alt_text": "Modern apartment buildings with a Wheaton World Wide Moving truck parked in the circular driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/R76RqLjlbWr_-4rAD_lyFHMKKSg3wfhprOLkr-noLMQ/114/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_7a61045965dd1416431939db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "poi_name": "Westshore Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_4bf300b2b727e56b91258ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "poi_name": "Monroe Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_c679f2355db3651d25811827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "poi_name": "Robinson High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_c332ce7c49429e18bbb802b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "poi_name": "Montessori Country Day School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_40f5b05368d7f6b910c8ea44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "poi_name": "Bayshore Christian School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_780ec86bc68f5d1b4fc56109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "poi_name": "Victory Christian Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_828f51be4c66644144b62c7d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "rating": "5",
      "name": "false",
      "text": "If you are looking for an upscale apartment in Tampa, this is a great choice. The apartment complex I was living at seemed like they started renting to \"anyone\". I was pleased to find out how thoroughly The Pointe screens and verifies prospective tenants. I will be the first one to live in my apartment, it is light and clean, and it is only a couple of hundred dollars more than my previous apartment. Every one of the ladies who works here is very sweet and helpful despite being overloaded with showing and leasing new apartments. I am excited to be moving in tomorrow.",
      "date": "false",
      "title": "My New Home"
    },
    {
      "id": "ec_32c7f7b6bfc2e07e06721aeb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "rating": "5",
      "name": "false",
      "text": "Ana the leasing agent was wonderful!  She took great care of us. Very friendly, patient and very knowledgeable of the apartments and the neighborhood. We looked at many places in Tampa and St Petersburg. We are looking forward to living at The Pointe. Thank you Ana for being so great. ",
      "date": "false",
      "title": "Ana the leasing agent and The Pointe are 5 star"
    },
    {
      "id": "ec_d9664dac01aacc02747313db",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "rating": "5",
      "name": "false",
      "text": "A superb property, for those with impeccable taste, the guest relations is handled like a concierge service, and the property is like a resort. The fitness center and pools are exceptional to any community that I have seen. Our apartment is spacious, private, our neighbors are great and they offer a variety with events. It's nice to have that connection after covid. If you're looking for a top-notch property in a great location with superior service look no further. ",
      "date": "false",
      "title": "We love living here!"
    },
    {
      "id": "ec_f70601866eeb788d808e3166",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "rating": "5",
      "name": "false",
      "text": "Probably one of the smoothest, easiest moves I have ever had! The leasing team at The Pointe on Westshore was there whenever I needed them with questions or concerns. Right from the beginning when I informed Waltesha that I was looking to move from my one bedroom apartment where I had lived for the past three years into a larger square footage apartment, she helped me find what I was looking for. I wanted to stay at The Pointe on Westshore, the entire staff: all the leasing agents, the maintenance crew, and the grounds team are so friendly and are excellent at their jobs. You just get to know them on almost a personal level. That’s what makes this place special, and why I call it home. Each staff member is always available to help out with whatever you need. A special thank you to Waltesha for all of your valuable assistance in my move! I absolutely recommend The Pointe on Westshore to anyone who is looking for a great place to live. ",
      "date": "false",
      "title": "A Smooth Move! "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_521fe0e7cd019cb7a2bd7e19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/0Qe2AOiFX6a?source=180"
    },
    {
      "id": "ec_9addaa6acd32c0f3867e1eae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "4950 W Prescott St Tampa, FL 33616",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/3g0r8g?source=180"
    },
    {
      "id": "ec_2895d61d4fd9af0e0a7ca330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2313-74ce-8045-6a44d1b43db7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and open-concept living area.",
        "public_id": "019cfddf-2313-74ce-8045-6a44d1b43db7",
        "storage_key": "property/6767906449162940/019cfddf-2313-74ce-8045-6a44d1b43db7.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "4950 W Prescott St Tampa, FL 33616",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5LGxbMaAasv"
    },
    {
      "id": "ec_b6d916b629af51d96f8ad858",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2cbd-76ef-892e-436d6ca2a262.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment living area with kitchen island, dining table, and view into bedroom.",
        "public_id": "019cfddf-2cbd-76ef-892e-436d6ca2a262",
        "storage_key": "property/6767906449162940/019cfddf-2cbd-76ef-892e-436d6ca2a262.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "4950 W Prescott St Tampa, FL 33616",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JeejC6wf71Z"
    },
    {
      "id": "ec_4df2ef02d838fc886132ded9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162940",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3007-73ed-9222-7c8c4065994d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island with bar stools.",
        "public_id": "019cfddf-3007-73ed-9222-7c8c4065994d",
        "storage_key": "property/6767906449162940/019cfddf-3007-73ed-9222-7c8c4065994d.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "4950 W Prescott St Tampa, FL 33616",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UqRUGhu75UK"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_text_field",
      "type": "STRING",
      "value": "Schedule a Tour | 1801 Metrowest"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    }
  ],
  "custom_text_field": "Schedule a Tour | 1801 Metrowest",
  "custom_rollout_phase": "Phase 1"
};

export const generatedAt = '2026-10-05T18:31:20.162Z';
